import { generatePath } from 'react-router-dom';

/** @typedef {import('../../propTypes/map/location').Location} Location */

export const mapPaths = {
  base: `/surf-reports-forecasts-cams-map`,
  baseWithLocation: `/surf-reports-forecasts-cams-map/@:location`,
  buoys: `/surf-reports-forecasts-cams-map/buoys`,
  buoysWithLocation: `/surf-reports-forecasts-cams-map/buoys/@:location`,
  geonameBase: `/surf-reports-forecasts-cams`,
  geonameBuoysBase: `/surf-reports-forecasts-cams/buoys`,
  geoname: `/surf-reports-forecasts-cams/:breadcrumbs+/:geonameId`,
  geonameBuoys: `/surf-reports-forecasts-cams/buoys/:breadcrumbs+/:geonameId`,
};

/** @param {Location} location */
export const locationObjectToString = (location) => {
  if (!location) {
    return null;
  }

  const {
    center: { lat, lon },
    zoom,
  } = location;

  return `${lat},${lon},${zoom}z`;
};

export const getSpotMapPath = () => generatePath(mapPaths.base);
export const getBuoyMapPath = () => generatePath(mapPaths.buoys);

/** @param {string} location */
export const getSpotMapPathWithLocation = (location) =>
  generatePath(mapPaths.baseWithLocation, { location });

/** @param {string} location */
export const getBuoyMapPathWithLocation = (location) =>
  generatePath(mapPaths.buoysWithLocation, { location });

/** @param {Location} location */
export const getSpotMapPathWithLocationObject = (location) =>
  generatePath(mapPaths.baseWithLocation, { location: locationObjectToString(location) });

/** @param {Location} location */
export const getBuoyMapPathWithLocationObject = (location) =>
  generatePath(mapPaths.buoysWithLocation, { location: locationObjectToString(location) });

/**
 * @param {object} params
 * @param {string} params.breadcrumbs
 * @param {string} params.geonameId
 */
export const getBuoyGeonameMapPath = ({ breadcrumbs, geonameId }) =>
  decodeURIComponent(generatePath(mapPaths.geonameBuoys, { breadcrumbs, geonameId }));

/**
 * @param {object} params
 * @param {string} params.breadcrumbs
 * @param {string} params.geonameId
 */
export const getGeonameMapPath = ({ breadcrumbs, geonameId }) =>
  decodeURIComponent(generatePath(mapPaths.geoname, { breadcrumbs, geonameId }));

/** @param {string} location */
export const transformLocationParam = (location) => {
  const splitLocation = location.split(',');
  return {
    center: {
      lat: Number(splitLocation[0]),
      lon: Number(splitLocation[1]),
    },
    zoom: Number(splitLocation[2].replace('z', '')),
  };
};
